<ng-container *ngIf="interviewQuestion.questionTypeMode === jobPostingInterviewMultipleChoiceTypes.singleSelect">
    <mat-radio-group [(ngModel)]="interviewerFeedback[0]" class="vertical">
        <mat-radio-button
            (change)="onSingleSelectChange($event)"
            *ngFor="let value of interviewQuestion.questionValues"
            [value]="value"
            required
            >{{ value }}</mat-radio-button
        >
    </mat-radio-group>
</ng-container>
<ng-container *ngIf="interviewQuestion.questionTypeMode === jobPostingInterviewMultipleChoiceTypes.multiSelect">
    <div *ngFor="let value of interviewQuestion.questionValues; let index = index">
        <mat-checkbox [checked]="checkboxValues[index]?.checked" (change)="onMultiSelectChange($event)" [value]="value">
            {{ value }}
        </mat-checkbox>
    </div>
</ng-container>
